export enum ViewMode {
    chart,
    table,
}
